import { useState } from 'react';

export interface LoginFormData {
  email: string;
  password: string;
}

export interface LoginValidationErrors {
  email?: string;
  password?: string;
  general?: string;
}

export function useLoginValidation() {
  const [errors, setErrors] = useState<LoginValidationErrors>({});

  const validate = (formData: LoginFormData): boolean => {
    const newErrors: LoginValidationErrors = {};

    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = 'E-mail é obrigatório';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(formData.email.trim()) || formData.email.includes('..')) {
      newErrors.email = 'E-mail inválido';
    }

    // Password validation
    if (!formData.password.trim()) {
      newErrors.password = 'Senha é obrigatória';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Senha deve ter pelo menos 6 caracteres';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const clearErrors = () => {
    setErrors({});
  };

  const setError = (field: keyof LoginValidationErrors, message: string) => {
    setErrors(prev => ({ ...prev, [field]: message }));
  };

  return {
    errors,
    validate,
    clearErrors,
    setError,
  };
}